<script>
  import HistoryRouter from './lib/HistoryRouter.svelte'
  import { wrap } from 'svelte-spa-router/wrap'
  import { replace } from './lib/historyNav.js'
  import {
    SITE_MODE,
    defaultPathForSite,
    redirectForSitePath,
    isHubSite,
  } from './lib/hostSite.js'
  import Login from './routes/Login.svelte'
  import Hub from './routes/Hub.svelte'
  import HubSettings from './routes/HubSettings.svelte'
  import DashboardShell from './routes/DashboardShell.svelte'

  const home = defaultPathForSite(SITE_MODE)

  function goHome() {
    replace(home)
    return false
  }

  function guardHub(detail) {
    const loc = (detail && detail.location) || window.location.pathname || '/'
    if (!isHubSite(SITE_MODE)) {
      replace(home)
      return false
    }
    const redir = redirectForSitePath(loc, SITE_MODE)
    if (redir) {
      replace(redir)
      return false
    }
    return true
  }

  function guardDashboard(detail) {
    const loc = (detail && detail.location) || window.location.pathname || '/'
    const redir = redirectForSitePath(loc, SITE_MODE)
    if (redir) {
      replace(redir)
      return false
    }
    if (isHubSite(SITE_MODE)) {
      replace('/hub')
      return false
    }
    return true
  }

  // One DashboardShell for all /dashboard/* so tab switches don't remount / leak polls.
  // dashboard.* → Hub (+ Settings); paper.* / live.* → filtered shell; local → full shell.
  const routes = {
    '/login': Login,
    '/hub': isHubSite(SITE_MODE)
      ? Hub
      : wrap({
          component: DashboardShell,
          conditions: [() => goHome()],
        }),
    '/hub/settings': wrap({
      component: HubSettings,
      conditions: [guardHub],
    }),
    '/hub/*': wrap({
      component: HubSettings,
      conditions: [
        (detail) => {
          if (!guardHub(detail)) return false
          const loc = (detail && detail.location) || ''
          if (loc === '/hub/settings' || loc.startsWith('/hub/settings/')) return true
          replace('/hub')
          return false
        },
      ],
    }),
    '/dashboard': wrap({
      component: DashboardShell,
      conditions: [() => goHome()],
    }),
    '/dashboard/*': wrap({
      component: DashboardShell,
      conditions: [guardDashboard],
    }),
    '/': wrap({
      component: isHubSite(SITE_MODE) ? Hub : DashboardShell,
      conditions: [
        () => {
          if (isHubSite(SITE_MODE)) return true
          return goHome()
        },
      ],
    }),
    '*': wrap({
      component: DashboardShell,
      conditions: [
        (detail) => {
          const loc = (detail && detail.location) || '/'
          if (loc.startsWith('/dashboard') || loc === '/hub' || loc.startsWith('/hub/')) {
            return guardDashboard(detail)
          }
          replace('/login')
          return false
        },
      ],
    }),
  }
</script>

<HistoryRouter {routes} />
